import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import SettingsPage from '@/pages/settings/settings-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'settings',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <SettingsPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'Preferences',
  },
});
